'use strict';

function isVariant(definition) {
    return typeof definition === "object";
}

exports.isVariant = isVariant;
